import { Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AddGroup from './AddGroup';
import {
  SubContent,
  useBreadcrumbRoutes,
  Wrapper,
  Button,
  Table,
  Modal,
  FormTitle,
  EllipsisSpan,
  useUpdate,
} from '@maxtropy/components';

import styles from './index.module.scss';
import {
  apiV2EnergyUnitGetGroupListPost,
  V2EnergyUnitGetGroupListPostResponse,
  apiV2EnergyUnitDeleteGroupPost,
} from '@maxtropy/device-customer-apis-v2';

const routes = [{ name: '分组配置' }];
export type GroupListProps = Exclude<V2EnergyUnitGetGroupListPostResponse['list'], undefined>;
export type editProps = Exclude<V2EnergyUnitGetGroupListPostResponse['list'], undefined>[number];
const Group: React.FC = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [loading, setLoading] = useState<boolean>(false);
  const [addGroupModal, setAddGroupModal] = useState<boolean>(false);
  const [editNodeData, setEditNodeData] = useState<editProps>();
  const [data, setData] = useState<GroupListProps>([]);
  const [updateState, update] = useUpdate();

  useEffect(() => {
    apiV2EnergyUnitGetGroupListPost({}).then(res => {
      setData(res.list ?? []);
    });
  }, [updateState]);

  const onDelete = (id: number) => {
    Modal.confirm({
      title: '确定删除？',
      content: '删除后不可恢复，你还要继续吗',
      okText: '继续',
      onOk: () => {
        apiV2EnergyUnitDeleteGroupPost({ id }).then(res => {
          update();
        });
      },
    });
  };

  const columns = [
    {
      title: '用组名称',
      dataIndex: 'groupName',
      render: (v: string) => <EllipsisSpan value={v} />,
    },
    {
      title: '用能分析组',
      dataIndex: 'energyUnitGroupName',
      render: (v: string) => <EllipsisSpan value={v} />,
    },
    {
      title: '用能单元',
      dataIndex: 'energyUnitList',
      render: (v: any) => {
        const arr = v.map((i: any) => i.energyUnitName);
        const name = arr.join(',');
        return <EllipsisSpan value={name} />;
      },
    },
    {
      title: '操作',
      fixed: 'right' as const,
      width: 340,
      render: (record: any) => (
        <Space size={16}>
          <Button
            type="link"
            onClick={() => {
              setEditNodeData(record);
              setAddGroupModal(true);
            }}
          >
            编辑
          </Button>

          <Button
            type="link"
            onClick={() => {
              onDelete(record.id);
            }}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];
  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? []), ...routes]} className={styles.detail}>
      <FormTitle title={routes[0].name} />
      <SubContent>
        <div style={{ marginBottom: 8 }}>
          <Button
            type="primary"
            onClick={() => {
              setEditNodeData(undefined);
              setAddGroupModal(true);
            }}
          >
            新建分组
          </Button>
        </div>
        <Table rowKey="id" scroll={{ x: 1900 }} loading={loading} columns={columns} dataSource={data} />
      </SubContent>
      <Space className="sticky-footer">
        <Button>
          <Link to={`/energy/analysis/ranking`}>返回</Link>
        </Button>
      </Space>
      {addGroupModal && (
        <AddGroup
          visible={addGroupModal}
          cabinet={editNodeData}
          updateFn={update}
          onClose={() => {
            setAddGroupModal(false);
            setEditNodeData(undefined);
          }}
        />
      )}
    </Wrapper>
  );
};

export default Group;
